/*
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-11-01 10:24:17
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2025-12-11 16:45:03
 */
import fetch from 'unfetch'
import { ApolloLink, from } from 'apollo-link'
import { onError } from 'apollo-link-error'
import { HttpLink } from 'apollo-link-http'
import { apiUrl } from '@/assets/js/config.js'
import router from '@/router'
import { vue } from '../../main'

const httpLink = new HttpLink({
    uri: apiUrl,
    fetch: fetch
})

// 授权白名单
const authWhiteList = [
    'smsLogin',
    'verifyValidationCode',
    'sendValidationCode',
    'register',
    'getThirdLoginUrl',
    'thirdLogin'
]

const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    if (!authWhiteList.includes(operation.operationName)) {
        operation.setContext({
            headers: {
                authorization: `bearer ${window.sessionStorage.getItem('token')}`,
                'accept-language': vue.$i18n.locale || window.localStorage.getItem('lang') || 'en-US'
            }
        })
    }
    return forward(operation)
})

const checkCodeLink = new ApolloLink((operation, forward) => {
    // 仅记录操作名称与耗时，不输出变量、响应或授权信息。
    const startedAt = Date.now()
    // 标记入口请求开始，方便识别始终未返回的请求。
    console.info('[H5 request]', operation.operationName, 'start')
    return forward(operation).map(response => {
        // 记录业务状态和耗时，不输出报告内容。
        console.info('[H5 request]', operation.operationName, 'end', Date.now() - startedAt, response.data && response.data[operation.operationName] && response.data[operation.operationName].code)
        // GraphQL 校验失败可能只有 errors，必须先判断 data。
        if (response.data && response.data.code === 401) {
            // TODO
            // 根据状态码处理
            window.location.href = '/exception/login'
            window.localStorage.removeItem('modelInfo')
            window.localStorage.removeItem('loginInfo')
        }
        try {
            if(response.errors){
                if(response.errors[0].message === 'Unauthorized'){
                    window.localStorage.removeItem('modelInfo')
                    window.localStorage.removeItem('loginInfo')
                    window.sessionStorage.removeItem('token')
                    window.localStorage.removeItem('memberInfo')
                    window.location.href = '/login?register=true'
                }
            } 
        } catch (error) {
            console.log(error)
        }
         
       
        return response
    })
})

// eslint-disable-next-line no-unused-vars
const errorLink = onError(({ networkError, graphQLErrors, operation }) => {
    // 仅记录错误类别与 GraphQL 标准错误码，避免业务错误携带隐私。
    console.error('[H5 request]', operation.operationName, networkError ? 'network-error' : 'graphql-error', (graphQLErrors || []).map(error => error.extensions && error.extensions.code))
    // 授权错误是重新登录
    if (graphQLErrors && graphQLErrors[0].message === 'Unauthorized') {
        // TODO
        // 这里跳转到登录重新授权
        window.localStorage.removeItem('modelInfo')
        window.localStorage.removeItem('loginInfo')
        window.localStorage.removeItem('token')
        const currentRoute = router.currentRoute
        console.log('router对象', currentRoute)
        router.push({
            path: '/login',
            query: { redirect: currentRoute.fullPath }
        })
    }
})

export const link = from([authMiddleware, checkCodeLink, errorLink, httpLink])
